/*
  Subscription labels resolve backend keys through the active language bundle
  and use the subscription record—not free entitlements—to decide whether the
  user has a paid plan.
*/
import type { SubscriptionOverview } from "./types";

export interface SubscriptionPlanLabelStrings {
  free: string;
  families: Record<string, string>;
  tiers: Record<string, string>;
}

export function formatSubscriptionPlanLabel(
  overview: SubscriptionOverview | null,
  strings: SubscriptionPlanLabelStrings
): string {
  if (!overview?.subscription) return strings.free;
  const familyKey = overview.subscription.planFamily;
  const tierKey = overview.subscription.planTier;
  const family = strings.families[familyKey] || familyKey;
  const tier = strings.tiers[tierKey] || tierKey;
  return [family, tier].filter(Boolean).join(" ") || strings.free;
}
